import { useTranslation } from 'react-i18next';
import { ExpandChevronCell } from '../../../../Components/BombiixAGGrid';

export interface ExpandAllHeaderProps {
  /** True when every expandable row is currently open. */
  allExpanded?: boolean;
  /** Toggles every expandable row; children are fetched on demand, so this may be async. */
  onToggleExpandAll?: () => void;
  /** Hidden while a bulk edit is open, so the open rows cannot be collapsed mid-edit. */
  disabled?: boolean;
}

/**
 * Expand/collapse-all control in the expand column's header, mirroring the PIM product table.
 *
 * Reuses the shared {@link ExpandChevronCell} in its controlled mode rather than rendering a
 * second chevron, so the header glyph and the per-row glyph stay identical by construction.
 * @param props expand state and toggle handler
 * @returns the header chevron, or nothing while a bulk edit holds the rows open
 */
function ExpandAllHeader(props: ExpandAllHeaderProps) {
  const { allExpanded = false, onToggleExpandAll, disabled = false } = props;
  const { t } = useTranslation('common');
  if (disabled) return null;
  return (
    <ExpandChevronCell
      expanded={allExpanded}
      onToggle={() => onToggleExpandAll?.()}
      expandLabel={t('COMMON_LABEL.EXPAND')}
      collapseLabel={t('COMMON_LABEL.COLLAPSE')}
    />
  );
}

export default ExpandAllHeader;
